import { render, staticRenderFns } from "./ViewImage.vue?vue&type=template&id=7318f872&scoped=true"
import script from "./ViewImage.vue?vue&type=script&lang=ts"
export * from "./ViewImage.vue?vue&type=script&lang=ts"
import style0 from "./ViewImage.vue?vue&type=style&index=0&id=7318f872&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7318f872",
  null
  
)

export default component.exports